import {Component, Input, NgZone, OnInit} from '@angular/core';
import {Host, IOpeningHours, relative_time, Table, TableType} from "../../../../common";

@Component({
  standalone: false,
  selector: 'opening-hours-warning',
  template: `
    <div class="mt-3 alert alert-danger" role="alert" *ngIf="!hasActiveTable() && hasDeliveryFeature()">
      <i class="fas fa-exclamation-triangle"></i>&nbsp;
      <span i18n>Temporarily closed.</span>
    </div>

    <div *ngIf="hasActiveTable()">
      <div class="mt-3 alert alert-warning" role="alert" *ngIf="!hours.isOpen">
        <i class="fas fa-exclamation-triangle"></i>&nbsp;
        <span i18n>Opens </span>{{ getRelativeTime() }}
      </div>

      <div class="mt-3 alert alert-warning" role="alert" *ngIf="hours.isOpen && hours.willCloseSoon">
        <i class="far fa-clock"></i>&nbsp;
        <span i18n>Closes in {{ hours.closesIn }} minutes.</span>
      </div>
    </div>
  `
})

export class OpeningHoursWarning implements OnInit {
  @Input() host: Host;
  @Input() table: Table;
  @Input() has_active_table: boolean;

  hours: IOpeningHours;
  interval: any;

  constructor(private readonly ngZone: NgZone) {
  }

  ngOnInit(): void {
    this.hours = this.host.getOpeningHours();
    // setInterval must run outside of angular, otherwise protractor E2E tests hang
    // https://github.com/angular/protractor/blob/master/docs/timeouts.md#angular
    this.ngZone.runOutsideAngular(() => {
      this.interval = setInterval(() => {
        this.ngZone.run(() => {
          this.hours = this.host.getOpeningHours()
        })
      }, 30000)
    })
  }

  hasActiveTable(): boolean {
    if (!this.table) {
      return false;
    }
    if (this.table.type == TableType.inhouse) {
      return this.table.is_active;
    } else {
      return this.host.has_delivery || this.host.has_takeout;
    }
  }

  hasDeliveryFeature(): boolean {
    return this.host.feature_flags.includes('DELIVERY');
  }

  getRelativeTime() {
    return relative_time(this.hours.opensAt, this.host)
  }

  ngOnDestroy() {
    clearInterval(this.interval);
  }

}
